import { useTranslation } from 'react-i18next';
import { Modal } from './Modal';
import Icon, { iconNames } from '../icon';
import { COLORS } from '../../../constants/colors';
import { SEO_CONFIG } from '../../../constants/seo';
import { trackEvent } from '../../../utils/common/analytics';

const TELEGRAM_CHANNEL_URL = 'https://t.me/worldautoge';

const TEXTS = {
    ge: {
        title: 'აირჩიეთ, სად გამოიწეროთ',
        facebook: 'გვერდი worldauto.ge — ავტო სიახლეები და ახალი მანქანები',
        telegram: 'არხი @worldautoge — ახალი მანქანები ფოტოებითა და ფასებით ყოველდღე',
    },
    ru: {
        title: 'Где подписаться?',
        facebook: 'Страница worldauto.ge — автоновости и свежие машины',
        telegram: 'Канал @worldautoge — свежие машины с фото и ценами каждый день',
    },
    en: {
        title: 'Where to follow us?',
        facebook: 'worldauto.ge page — car news and fresh cars',
        telegram: '@worldautoge channel — fresh listings with photos and prices every day',
    },
    ua: {
        title: 'Де підписатися?',
        facebook: 'Сторінка worldauto.ge — автоновини та свіжі авто',
        telegram: 'Канал @worldautoge — свіжі оголошення з фото та цінами щодня',
    },
};

const CHANNELS = [
    {
        network: 'facebook',
        name: 'Facebook',
        url: SEO_CONFIG.socialLinks.facebook,
        icon: <Icon name={iconNames.facebook} size={44} />,
    },
    {
        network: 'telegram',
        name: 'Telegram',
        url: TELEGRAM_CHANNEL_URL,
        icon: <Icon name={iconNames.telegram} size={24} fill={COLORS.WHITE} />,
    },
];

export const SocialFollowModal = ({ isOpen, onClose, placement }) => {
    const { t, i18n } = useTranslation();
    const text = TEXTS[i18n.language] || TEXTS.en;

    const handleClick = (network) => {
        trackEvent('social_click', { network, placement });
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={text.title}
            withContinue
            text={t('exit')}
        >
            <div className="social-modal">
                {CHANNELS.map(({ network, name, url, icon }) => (
                    <a
                        key={network}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`social-modal__option social-modal__option--${network}`}
                        onClick={() => handleClick(network)}
                    >
                        <div className="social-modal__icon">{icon}</div>
                        <div className="social-modal__info">
                            <div className="social-modal__title">{name}</div>
                            <div className="social-modal__subtitle">
                                {text[network]}
                            </div>
                        </div>
                        <div className="social-modal__arrow" aria-hidden="true">
                            →
                        </div>
                    </a>
                ))}
            </div>
        </Modal>
    );
};

export default SocialFollowModal;
